export const articles = [
  {
    number: '01',
    slug: 'montatore-video-montatore-televisivo-differenze',
    title: 'Montatore video e montatore televisivo non sono lo stesso mestiere',
    subtitle: 'Possono utilizzare gli stessi software e lavorare davanti alla stessa timeline, ma si muovono dentro processi, responsabilità e tempi molto diversi.',
    category: 'Mestieri',
    readingTime: '8 min',
    file: '01.md',
    datePublished: '2026-07-17',
    dateModified: '2026-07-17',
    image: '/inside-og/inside-01.png',
  },
  {
    number: '02',
    slug: 'ingest-post-produzione-televisiva-cosa-fa',
    title: 'Che cosa fa davvero un ingest',
    subtitle: 'Non è semplicemente la persona che importa il materiale e prepara i progetti. In molte produzioni televisive è la figura che impedisce alla post-produzione di fermarsi.',
    category: 'Mestieri',
    readingTime: '11 min',
    file: '02.md',
    datePublished: '2026-07-17',
    dateModified: '2026-07-17',
    image: '/inside-og/inside-02.png',
  },
  {
    number: '03',
    slug: 'passaparola-lavoro-televisivo',
    title: 'Il talento non dovrebbe dipendere dalla rubrica giusta',
    subtitle: 'Il passaparola offre velocità e fiducia. Quando diventa l’unico sistema, però, rende invisibili professionisti validi e limita anche chi sta cercando.',
    category: 'Carriera',
    readingTime: '15 min',
    file: '03.md',
    datePublished: '2026-07-17',
    dateModified: '2026-07-17',
    image: '/inside-og/inside-03.png',
  },
  {
    number: '04',
    slug: 'come-funziona-post-produzione-programma-tv',
    title: 'Un programma TV non finisce quando termina la registrazione',
    subtitle: 'È in post-produzione che ore di girato, persone, musiche, grafiche e decisioni editoriali diventano un episodio pronto per andare in onda.',
    category: 'Workflow',
    readingTime: '13 min',
    file: '04.md',
    datePublished: '2026-07-17',
    dateModified: '2026-07-17',
    image: '/inside-og/inside-04.png',
    featured: true,
  },
  {
    number: '05',
    slug: 'avid-premiere-davinci-post-produzione-tv',
    title: 'Avid, Premiere o DaVinci: cosa si usa davvero nella televisione',
    subtitle: 'La domanda non è quale sia il software migliore, ma quale permetta a un intero reparto di lavorare insieme senza trasformare ogni puntata in un esperimento.',
    category: 'Strumenti',
    readingTime: '12 min',
    file: '05.md',
    datePublished: '2026-07-17',
    dateModified: '2026-07-17',
    image: '/inside-og/inside-05.png',
    sources: [
      { label: 'Avid Media Composer e collaborazione', url: 'https://www.avid.com/media-composer' },
      { label: 'Adobe Team Projects e Productions', url: 'https://helpx.adobe.com/premiere/desktop/collaborate-with-others/collaborate-using-team-projects/collaboration-using-team-projects.html' },
      { label: 'DaVinci Resolve Collaboration', url: 'https://www.blackmagicdesign.com/products/davinciresolve/collaboration' },
    ],
  },
  {
    number: '06',
    slug: 'curriculum-crediti-post-produzione-tv',
    title: 'Aver lavorato a un programma non racconta come ci hai lavorato',
    subtitle: 'I crediti televisivi sono importanti, ma non dicono quanto eri autonomo, quali responsabilità avevi e che tipo di professionista sei quando il lavoro diventa complicato.',
    category: 'Carriera',
    readingTime: '12 min',
    file: '06.md',
    datePublished: '2026-07-17',
    dateModified: '2026-07-17',
    image: '/inside-og/inside-06.png',
  },
  {
    number: '07',
    slug: 'lo-sistemiamo-in-post-limiti-post-produzione',
    title: '“Lo sistemiamo in post” non è un piano di produzione',
    subtitle: 'La post può risolvere molti problemi, ma non inventare immagini inesistenti, recuperare informazioni mai registrate o trasformare automaticamente una mancanza in una scelta creativa.',
    category: 'Cultura della post',
    readingTime: '15 min',
    file: '07.md',
    datePublished: '2026-07-17',
    dateModified: '2026-07-17',
    image: '/inside-og/inside-07.png',
  },
  {
    number: '08',
    slug: 'frasi-che-fanno-paura-montatore-televisivo',
    title: '“È solo una piccola modifica” e altre frasi che terrorizzano un montatore',
    subtitle: 'Alcune sembrano innocue, altre arrivano con un tono rassicurante. Quasi tutte nascondono più lavoro di quanto lascino immaginare.',
    category: 'Cultura della post',
    readingTime: '14 min',
    file: '08.md',
    datePublished: '2026-07-17',
    dateModified: '2026-07-17',
    image: '/inside-og/inside-08.png',
  },
  {
    number: '09',
    slug: 'finalizzatore-editoriale-head-editor-cosa-fa',
    title: 'Il montatore costruisce la puntata. Il finalizzatore deve farla funzionare tutta',
    subtitle: 'Il finalizzatore editoriale rende coerenti lavori diversi, assorbe le note e controlla equilibri, tono e durata fino a trasformare molte sequenze in un unico programma.',
    category: 'Mestieri',
    readingTime: '17 min',
    file: '09.md',
    datePublished: '2026-07-17',
    dateModified: '2026-07-17',
    image: '/inside-og/inside-09.png',
  },
  {
    number: '10',
    slug: 'come-costruire-reparto-post-produzione-televisiva',
    title: 'Un reparto di post-produzione non si costruisce riempiendo delle sale',
    subtitle: 'Mettere insieme ingest, assistenti, montatori e finalizzatori non basta. Il reparto funziona quando ruoli, tempi e responsabilità sono parti dello stesso processo.',
    category: 'Workflow',
    readingTime: '16 min',
    file: '10.md',
    datePublished: '2026-07-17',
    dateModified: '2026-07-17',
    image: '/inside-og/inside-10.png',
  },
];

export const categories = ['Tutti', ...Array.from(new Set(articles.map((article) => article.category)))];

export function getArticle(slug) {
  return articles.find((article) => article.slug === slug);
}

export function getAdjacentArticles(slug) {
  const index = articles.findIndex((article) => article.slug === slug);
  return {
    previous: index > 0 ? articles[index - 1] : null,
    next: index >= 0 && index < articles.length - 1 ? articles[index + 1] : null,
  };
}
